/** @graphql cc **/

import gql from 'graphql-tag';

import { ConfluencePageAri } from '@atlassian/ari';

import { getApolloClient } from '@confluence/graphql/entry-points/getApolloClient';
import { getSessionData } from '@confluence/session-data';

import type { AutomatedMeetingNotesPagePropertiesResult } from '../__types__/AutomatedMeetingNotesPagePropertiesResult';

import type {
	useAutomatedMeetingNotesPagePropertiesQuery as getAutomatedMeetingNotesPagePropertiesQuery$data,
	useAutomatedMeetingNotesPagePropertiesQueryVariables as getAutomatedMeetingNotesPagePropertiesQuery$variables,
} from './__types__/useAutomatedMeetingNotesPagePropertiesQuery';
import { extractAmnPageProperties } from './useAutomatedMeetingNotesPageProperties';

const getAutomatedMeetingNotesPagePropertiesQuery = gql`
	query getAutomatedMeetingNotesPagePropertiesQuery($pageAri: ID!) {
		page(id: $pageAri) {
			properties(keys: ["isAutomatedMeetingNotes", "meetingRecurrenceAri"]) {
				nodes {
					key
					value
				}
			}
			subType
		}
	}
`;

export type getAmnPagePropertyQueryResult = Omit<
	AutomatedMeetingNotesPagePropertiesResult,
	'isLoading'
>;

export const getAutomatedMeetingNotesPageProperties = async (
	pageId: string,
): Promise<getAmnPagePropertyQueryResult> => {
	const { cloudId } = await getSessionData();
	const pageAri = ConfluencePageAri.create({
		siteId: cloudId,
		pageId,
	}).toString();

	// There is no non-hook alternative for getApolloClient AFAIK
	// eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations
	const { data } = await getApolloClient().query<
		getAutomatedMeetingNotesPagePropertiesQuery$data,
		getAutomatedMeetingNotesPagePropertiesQuery$variables
	>({
		query: getAutomatedMeetingNotesPagePropertiesQuery,
		variables: { pageAri },
		errorPolicy: 'none',
	});

	return extractAmnPageProperties(data);
};
